"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findUsersByDepartmentIdsQuery = exports.findUserByEmail = exports.findUserByIdQuery = void 0;
const types_1 = require("../../types");
exports.findUserByIdQuery = `
    query findUserByIdQuery($id: ID!) {
        findUserByIdQuery(id: $id) {
            ...user
        }
    }
    ${types_1.userFragment}
`;
exports.findUserByEmail = `
    query findUserByEmailQuery($email: String!) {
        findUserByEmail(email: $email) {
            ...user
        }
    }
    ${types_1.userFragment}
`;
exports.findUsersByDepartmentIdsQuery = `
    query findUsersByDepartmentIdsQuery($departmentIds: [String!]) {
        findUsersByDepartmentIds(departmentIds: $departmentIds) {
            ...user
        }
    }
    ${types_1.userFragment}
`;
//# sourceMappingURL=user.js.map